module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/670b1699f94bdcb72d9bfea5da334337.png";